export let { NODE_ENV } = process.env;

export const REGISTRATION_NUMBER_LENGTHS = [6, 7];
export const ISRAELIID_LENGTHS = [9];

export const MAIN_URL =
  NODE_ENV === "test" || NODE_ENV === "production"
    ? ""
    : // : "http://localhost:4001";
      "https://paneem.claimscon.org";

export const SP_URL =
  NODE_ENV === "production" ? "https://survivorsportal.claimscon.org/" : "https://survivorsportaltest.claimscon.org/";

export const MAX_EMAIL_LENGTH = 320;

export const EMAIL_REGEXP = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[A-Za-z]+$/;

export const english_regex_spec_char = /^[A-Za-z0-9'"`\-,.!?&@#$%^*()_+=<>;:|\\[\]{} ]*$/;

export const notDigits = /^([^0-9]*)$/;

export const onlyDigts = /^\d+$/;

export const onlyDigitsWithSpaces = /^[\d\s]+$/;

export const digits_letters_only = /^[A-Za-z0-9]+$/;

export const PHONE_NUMBER_REGEX = /^[0-9]{7,15}$/;

export const PHONE_NUMBER_DIGITS_REGEX = /^[0-9\s]*$/;

export const PHONE_REGEXP_TEXT = `^[\\+][0-9]{MIN,MAX}$`;

export const PHONE_RANGE_REGEXP_TEXT = `^\\D*\\d{MIN,MAX}\\D*$`;

export const REGULA_BASE_URL = "/proxy";

export const ADMIN_TABS = ["ENTRIES", "TOTALS", "QUEUE"];

export const TABLE_HEAD_PROPS = [
  { id: "id", label: "ID" },
  { id: "registrationNumber", label: "RegNum" },
  { id: "currentStatus", label: "Current Status" },
  { id: "birthDate", label: "Birth Date" },
  { id: "country", label: "Country" },
  { id: "documentType", label: "Document" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
  { id: "status", label: "Status" },
  { id: "createdAt", label: "Date" },
  { id: "source", label: "Source" },
];

export const SECONDARY_ATTRIBUTES_1 = [
  { id: "firstAuditUser", label: "User" },
  { id: "firstAuditTime", label: "Time" },
  { id: "firstAuditDecision", label: "Decision" },
  { id: "firstAuditReason", label: "Reason" },
  { id: "firstAuditComment", label: "Comment" },
];

export const SECONDARY_ATTRIBUTES_2 = [
  { id: "secondAuditUser", label: "User" },
  { id: "secondAuditTime", label: "Time" },
  { id: "secondAuditDecision", label: "Decision" },
  { id: "secondAuditReason", label: "Reason" },
  { id: "secondAuditComment", label: "Comment" },
];

export const SECONDARY_ATTRIBUTES_3 = [
  { id: "thirdAuditUser", label: "User" },
  { id: "thirdAuditTime", label: "Time" },
  { id: "thirdAuditDecision", label: "Decision" },
  { id: "thirdAuditReason", label: "Reason" },
  { id: "thirdAuditComment", label: "Comment" },
];

export enum Subdomains {
  users = "/users",
  admins = "/admins",
  queue = "/queue",
  contactInfo = "/contact_info",
}

export enum PublicEndpoints {
  eulas = "/EULA/LANG",
  faqs = "/FAQ/TYPE/LANG",
  portal = "/portal/get_data",
  privacyPolicies = "/privacy_policy/LANG",
  info = "/info",
}

export enum QueueEndpoints {
  getClaimsTypes = "/getClaimsTypes",
  getAttemptsForReview = "/getAttemptsForReview",
  checkUnderReview = "/check_under_review",
  cleanUnderReview = "/cleanUnderReview",
  decision = "/decision",
}

export enum UserEndpoints {
  validationByRegNum = "/validate_by_regNum",
  validationByIsraeliId = "/validate_by_israeliId",
  registration = "/register",
  authentication = "/authenticate",
  statusCheckRegNum = "/status_regNum/REGNUM/DOB/LANG",
  statusCheckIsraeliId = "/status_israeiId/ISRAELI_ID/DOB/LANG",
  getContactInfo = "/getContactInfo",
  confirmContactInfo = "/confirmContactInfo",
}

export enum AdminEndpoints {
  login = "/login",
  reLogIn = "/ping",
  logout = "/logout",
  images = "/user_images/ID",
  countReset = "/reset_count",
  documentFlip = "/flip_document",
  allEntries = "/all_entries/PAGE",
  searchByRegNum = "/searchByRegNum/REGNUM",
  searchByIsraeliId = "/searchByIsraeliId/ISRAELI_ID",
  passwordChange = "/change_password",
  singleEntry = "/single_entry/REGNUM",
  totals = "/totals",
  delete = "/delete_case",
  getRoles = "/getRoles",
  newUser = "/newUser",
  switchStatus = "/switch_to_authenticate",
}

export enum ReplaceParams {
  id = "ID",
  page = "PAGE",
  token = "TOKEN",
  language = "LANG",
  fileType = "TYPE",
  birthDate = "DOB",
  minimum = "MIN",
  maximum = "MAX",
  israeliId = "ISRAELI_ID",
  registrationNumber = "REGNUM",
}

export enum AppRoutes {
  home = "/",
  infoPage = "/infoPage",
  completion = "/completed",
  portal = "/portal",
  adminLogin = "/admin_login",
  adminPanel = "/admin_panel",
  overrideAttempts = "/override/:number",
  authentication = "/auth",
}

export enum Statuses {
  pending = "pending",
  approved = "approved",
  A2Review = "A2 review",
  duplicate = "duplicate",
  authenticated = "authed",
  A2Authenticate = "A2 auth",
  duplicateAuthenticate = "dup auth",
  pendingAuthentication = "authenticate",
}

export enum LocalStorageKeys {
  language = "language",
}
